// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@keller/Overrides/Widgets/SignIn/SignInExistingAccount";
import { css } from "styled-components";

signInExistingAccountStyles.rememberMeGridItem = {
    width: 12,
    css: css`
        position: relative;
        padding-top: 6px;
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
    `,
};
